import { module } from 'angular'
import uiRouterModule from 'angular-ui-router'
import nominasCargacontpaqModule from 'nominas/cargacontpaq'
import nominasCarganominaasalariadosModule from 'nominas/carganominaasalariados'
import nominasCargaserviciosModule from 'nominas/cargaservicios'
import nominasCfdiModule from 'nominas/cfdi'
import nominasCotizacionModule from 'nominas/cotizacion'
import nominasCotizacionesModule from 'nominas/cotizaciones'
import nominasDonacionesModule from 'nominas/donaciones'
import nominasEmpresasconceptosModule from 'nominas/empresasconceptos'
import nominasFiniquitoModule from 'nominas/finiquito'
import nominasFiniquitosModule from 'nominas/finiquitos'
import nominasFondoreservaModule from 'nominas/fondoreserva'
import nominasInformacionfiscalModule from 'nominas/informacionfiscal'
import nominasNominaModule from 'nominas/nomina'
import nominasPendientesModule from 'nominas/pendientes'
import nominasSumarioModule from 'nominas/sumario'

export default module('nominas', [
  nominasCargacontpaqModule,
  nominasCarganominaasalariadosModule,
  nominasCargaserviciosModule,
  nominasCfdiModule,
  nominasCotizacionModule,
  nominasCotizacionesModule,
  nominasDonacionesModule,
  nominasEmpresasconceptosModule,
  nominasFiniquitoModule,
  nominasFiniquitosModule,
  nominasFondoreservaModule,
  nominasInformacionfiscalModule,
  nominasNominaModule,
  nominasPendientesModule,
  nominasSumarioModule,
  uiRouterModule,
  'interface',
])



// WEBPACK FOOTER //
// ./src/nominas/module.js